// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__2Q2yj","buttons":"PendingPaymentAlert_buttons__3LdKI"};